import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
import icons from './icons';
export default function InternalIcon(_a) {
    var name = _a.name, _b = _a.size, size = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'normal' : _c, url = _a.url, alt = _a.alt, _d = _a.__internalRootRef, __internalRootRef = _d === void 0 ? null : _d, props = __rest(_a, ["name", "size", "variant", "url", "alt", "__internalRootRef"]);
    var baseProps = getBaseProps(props);
    baseProps.className = clsx(baseProps.className, styles.icon, styles["size-" + size], styles["variant-" + variant]);
    if (url) {
        return (React.createElement("span", __assign({}, baseProps, { ref: __internalRootRef }),
            React.createElement("img", { src: url, alt: alt })));
    }
    return (
    // dangerouslySetInnerHTML is safe here, as we control the content coming from `icons`
    // eslint-disable-next-line react/no-danger
    React.createElement("span", __assign({}, baseProps, { dangerouslySetInnerHTML: name ? { __html: icons[name] } : undefined, ref: __internalRootRef })));
}
//# sourceMappingURL=internal.js.map